import SignUp from './pages/SignUp';
import SignIn from './pages/SignIn';

type Route = {
  path: string;
  name: string;
  key?: string;
  component?: React.ReactNode;
  hideInMenu?: boolean;
  children?: Route[];
}

const routes: Route[] = [
  {
    path: '/customers/sign_up',
    name: 'sign_up',
    component: SignUp,
    hideInMenu: true
  },
  {
    path: '/customers/sign_in',
    name: 'sign_in',
    component: SignIn,
    hideInMenu: true
  },
];

export default routes;